module.exports = __webpack_public_path__ + "static/media/pound-sign.799a9cc0.svg";